import React from 'react';

const TableRolesReadOnly = () => {
  // Sample data
  const data = [
    { no: 1, role: 'Admin', desc: 'All Permissions' },
    { no: 2, role: 'IT Section', desc: ['Hide/Unhide(Video,Buget Speech,Rulings,Address)', 'Create(Video,Buget Speech,Rulings,Address)', 'Update(Video,Buget Speech,Rulings,Address)', 'Update Thumbnail(Video,Buget Speech,Rulings,Address)', 'Publish Video(Video)', 'Update Sequence Number(Video,Buget Speech,Rulings,Address)', 'Create Highlight Videos', 'Add Youtube link', 'Adding Homepage carousel image', 'Create/Update(KLA,Session,Member,Constituency,Reservation,Role,Salutation,Member Mapping,Constituency Mapping,Event)', 'Upload homepage Speaker Image'] },
    { no: 3, role: 'Meta Data Entry and Approval', desc: ['Create(Video,Buget Speech,Rulings,Address)','Update(Video,Buget Speech,Rulings,Address)','Update Thumbnail(Video,Buget Speech,Rulings,Address)','Update Sequence Number(Video,Buget Speech,Rulings,Address)','Create/Update(KLA,Session,Member,Constituency,Reservation,Role,Salutation,Member Mapping,Constituency Mapping,Event)','Upload homepage Speaker Image'] },
    { no: 4, role: 'Video Uploading and Publishing', desc: ['Create(Video,Buget Speech,Rulings,Address)','Update(Video,Buget Speech,Rulings,Address)','Update Thumbnail(Video,Buget Speech,Rulings,Address)','Publish Video(Video)','Update Sequence Number(Video,Buget Speech,Rulings,Address)','Create Highlight Videos 8.Add Youtube link '] },
    { no: 5, role: 'Video Editor', desc: ['Hide/Unhide(Video,Buget Speech,Rulings,Address)','Create(Video,Buget Speech,Rulings,Address)','Update(Video,Buget Speech,Rulings,Address)','Update Thumbnail(Video,Buget Speech,Rulings,Address)','Update Sequence Number(Video,Buget Speech,Rulings,Address)'] },
    { no: 6, role: 'Proceeding Uploading and Publishing', desc: 'Add/Update/Delete Proceedings ,List Of Buisness' },
  ];
   


  return (
    <div className="container mx-auto p-4">
      <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md">
        <thead className="bg-gray-100 text-gray-600">
          <tr>
            <th className="py-2 px-4 border-b  border-gray-700 text-left">Sl no</th>
            <th className="py-2 px-4 border-b  border-gray-700 text-left">Role</th>
            <th className="py-2 px-4 border-b  border-gray-700 text-left">Description</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} className="hover:bg-gray-50">
              <td className="py-2 px-4 border-b border-gray-700">{row.no}</td>
              <td className="py-2 px-4 border-b  border-gray-700">{row.role}</td>
              <td className="py-2 px-4 border-b  border-gray-700">
                {Array.isArray(row.desc) ? (
                  <ol className="list-decimal pl-5">
                    {row.desc.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ol>
                ) : (
                  row.desc
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableRolesReadOnly;
